import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

import LoginMobile from "./LoginMobile.js";
import LoginDesktop from "./LoginDesktop.js";
import CodeEntry from "./CodeEntry.js";

import { AuthorizationCheck } from '../../utils/AuthorizationCheck';

const Home = ({auth}) => {

    const location = useLocation();
    const [step, setStep] = useState('email'); // 'email' or 'code'
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [cooldownSeconds, setCooldownSeconds] = useState(0);

    // Reset to email step when navigating to /login (e.g. clicking Login in navbar)
    useEffect(() => {
        setStep('email');
        setStatus('');
    }, [location.key]);

    // Cooldown timer
    useEffect(() => {
        if (cooldownSeconds <= 0) return;
        const timer = setTimeout(() => setCooldownSeconds(cooldownSeconds - 1), 1000);
        return () => clearTimeout(timer);
    }, [cooldownSeconds]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('');
        try {
            const res = await axios.post('/auth/send-code', { email });
            if (res.data.sent) {
                setStep('code');
                setCooldownSeconds(60);
            }
        } catch (err) {
            console.error('Error sending login code:', err);
            setStatus('Something went wrong. Please try again.');
        }
    };

    const handleResend = useCallback(async () => {
        try {
            await axios.post('/auth/send-code', { email });
            setCooldownSeconds(60);
        } catch (err) {
            console.error('Error resending login code:', err);
        }
    }, [email]);

    const handleBack = useCallback(() => {
        setStep('email');
        setStatus('');
    }, []);

    if ( AuthorizationCheck(auth, 'Private Beta', false) ) {
        return <Redirect to="/dashboard" />;
    }

    // Code entry step
    if (step === 'code') {
        return (<>
            <Helmet>
              <meta name="robots" content="noindex, nofollow" />
              <title>Enter Code - Spawnry</title>
            </Helmet>
            <CodeEntry
                email={email}
                cooldownSeconds={cooldownSeconds}
                onResend={handleResend}
                onBack={handleBack}
            />
        </>);
    }

    // Email entry step
    return (<>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
          <title>Login - Spawnry</title>
        </Helmet>
        {/*MOBILE*/}
        <div className="d-block d-md-none">
            <LoginMobile
                handleSubmit={handleSubmit}
                email={email}
                setEmail={setEmail}
                status={status}
            />
        </div>

        {/*TABLET*/}
        <div className="d-none d-md-block d-lg-none">
            <LoginMobile
                handleSubmit={handleSubmit}
                email={email}
                setEmail={setEmail}
                status={status}
            />
        </div>

        {/*DESKTOP*/}
        <div className="d-none d-lg-block">
            <LoginDesktop
                handleSubmit={handleSubmit}
                email={email}
                setEmail={setEmail}
                status={status}
            />
        </div>
    </>);
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Home);
